import React from "react"
import Layout from "../components/layout"
import Container from "../components/layoutComponents/Container"
import Header from "../components/layoutComponents/Header"
import Section from "../components/layoutComponents/Section"
import H1 from "../components/typography/H1"
import H2 from "../components/typography/H2"
import P from "../components/typography/P"

const seo = {
  title: "Mobile Terms",
  description: "Read MindMe's Mobile Terms of Use",
}

const main = (
  <>
    <Header>
      <Container className="padding-b-0">
        <div>
          <div style={{ height: "80px" }} />
          <H1>Mobile Terms</H1>
          <P>Last Updated: July 1, 2021</P>
        </div>
      </Container>
    </Header>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">MINDME ALERTS</H2>
          <P>
            MindMe Alerts provides query and alert services that offer
            informative content about mobile marketing to subscribers via short
            code 26786, toll free numbers and long codes. This is a
            standard-rate, recurring SMS and MMS program and message and data
            rates may apply. Subscribers agree to receive messages from or on
            behalf of MindMe and understand that consent is not a condition of
            purchase.
          </P>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">For Help</H2>
          <P>
            If you need assistance, send HELP to 26786 or applicable toll-free
            number or local long code number at any time to receive program
            contact information.
          </P>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">Opt-Out</H2>
          <P>
            To cancel your MindMe Alerts subscription, send STOP, QUIT, END,
            CANCEL, or UNSUBSCRIBE to 26786 or applicable toll-free number or
            local long code number to opt out of all messages.
          </P>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">For Help</H2>
          <P>
            If you need assistance, send HELP to 26786 or applicable toll-free
            number or local long code number at any time to receive program
            contact information.
          </P>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">Active Keywords</H2>
          <P>INFO, ALERTS, MMS, STOP, QUIT, END, CANCEL, UNSUBSCRIBE</P>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">Contact Us</H2>
          <P>
            If you have additional questions or comments, please contact us by
            email at support@mindmemobile.com or phone +1 855-551-0500.
          </P>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">Supported Carriers</H2>
          <P>
            MindMe Alerts is available on the following carriers: AT&T,
            T-Mobile, Verizon, and others. Carriers are not liable for delayed
            or undelivered messages. See the complete list below.
          </P>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container className="padding-b-0">
        <div>
          <H2 align="left">MindMe Alerts SMS:</H2>
          <ul>
            <li>AT&T</li>
            <li>Sprint</li>
            <li>T-Mobile</li>
            <li>Verizon Wireless</li>
            <li>All West Communications</li>
            <li>ACS Wireless</li>
            <li>Appalachian Wireless</li>
            <li>AWCC</li>
            <li>Bluegrass Cellular</li>
            <li>Boost</li>
            <li>Carolina West Wireless</li>
            <li>Cellcom</li>
            <li>Cellular South (C-Spire)</li>
            <li>Chariton Valley Wireless</li>
            <li>Chat Mobility</li>
            <li>Cincinnati Bell</li>
            <li>Copper Valley</li>
            <li>Cox Wireless</li>
            <li>Cricket</li>
            <li>CTC Telecom</li>
            <li>DTC Wireless</li>
            <li>Duet IP</li>
            <li>Eagle Telephone System</li>
            <li>ECIT</li>
            <li>Element Mobile (Flat Wireless)</li>
            <li>Epic Touch</li>
            <li>Farmers Mutual Telephone</li>
            <li>GCI Communications</li>
            <li>Gold Star Communications</li>
            <li>Golden State</li>
            <li>Google Voice</li>
            <li>Illinois Valley Cellular</li>
            <li>Immix Wireless (Keystone)</li>
            <li>Inland Cellular</li>
            <li>iWireless (Iowa Wireless)</li>
            <li>Manti Tel</li>
            <li>Metro PCS</li>
            <li>Mobi PCS</li>
            <li>Mobile Nation SI Wireless</li>
            <li>Mosaic</li>
            <li>MTA</li>
            <li>MTPCS Cellular One</li>
            <li>Nex-Tech</li>
            <li>nTelos</li>
            <li>NW Missouri Cellular</li>
            <li>Nucla-Naturita Tel</li>
            <li>Peoples Wireless</li>
            <li>Pine Cellular</li>
            <li>Pioneer Cellular</li>
            <li>Plateau Telecomm</li>
            <li>PTCI</li>
            <li>South Central Utah</li>
            <li>SouthernLINC Wireless</li>
            <li>SRT Wireless</li>
            <li>Syringa Wireless</li>
            <li>Thumb Cellular</li>
            <li>UBET</li>
            <li>United Wireless</li>
            <li>US Cellular</li>
            <li>Viaero Wireless</li>
            <li>Virgin Mobile</li>
            <li>West Central Cellular</li>
          </ul>
        </div>
      </Container>
    </Section>
    <Section className="padding-tb-0">
      <Container>
        <div>
          <H2 align="left">MindMe Alerts MMS:</H2>
          <ul>
            <li>AT&T</li>
            <li>T-Mobile</li>
            <li>Verizon Wireless</li>
            <li>Cricket/Leap</li>
            <li>US Cellular</li>
          </ul>
        </div>
      </Container>
    </Section>
  </>
)

const MobileTermsPage = () => <Layout main={main} seo={seo} />

export default MobileTermsPage
